export const STORAGE_KEY_DYNAMIC_LAST_USER_INFO = 'DYN-LAST-USER-INFO--';
export const STORAGE_KEY_FAILURE_BANK_TRANSFER_ENABLED = 'failureBankTransferEnabled';



// WEBPACK FOOTER //
// ./src/constants/storage.js